"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackNonMonetizingShoppingFinished = exports.getProductImpressionPayload = void 0;
require("core-js/modules/es6.regexp.replace.js");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _analytics = _interopRequireDefault(require("@nerdwallet/analytics"));
var _apollo = require("@nerdwallet/apollo");
var _constants = require("./constants");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
/**
 * Returns all fields expected by product_shopping_attributes
 * https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/product_shopping_attributes.yaml
 */
var getProductShoppingAttributes = function getProductShoppingAttributes(_ref) {
  var analyticsProps = _ref.analyticsProps,
    monetizable = _ref.monetizable,
    productType = _ref.productType;
  return {
    marketplace_product_type: productType,
    marketplace_institution_id: analyticsProps === null || analyticsProps === void 0 ? void 0 : analyticsProps.institutionId,
    marketplace_product_id: analyticsProps === null || analyticsProps === void 0 ? void 0 : analyticsProps.productId,
    marketplace_offer_id: analyticsProps === null || analyticsProps === void 0 ? void 0 : analyticsProps.offerId,
    monetizable: monetizable,
    driver: _constants.PRODUCT_DISPLAY_DRIVER
  };
};
getProductShoppingAttributes.fragment = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  fragment getProductShoppingAttributes on MarketplaceEntityInterface {\n    productType\n\n    ... on MarketplaceEntityWithPlacementInterface {\n      analyticsProps {\n        institutionId\n        offerId\n        productId\n      }\n      monetizable\n    }\n  }\n"])));

/**
 * Returns all payload fields expected by the product_impression event
 * https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/product_impression.yaml
 */
var getProductImpressionPayload = function getProductImpressionPayload(gqlMarketplaceEntity) {
  return (0, _objectSpread2.default)({}, getProductShoppingAttributes(gqlMarketplaceEntity));
};
exports.getProductImpressionPayload = getProductImpressionPayload;
getProductImpressionPayload.fragment = (0, _apollo.gql)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  fragment getProductImpressionPayload on MarketplaceEntityInterface {\n    ...getProductShoppingAttributes\n  }\n  ", "\n"])), getProductShoppingAttributes.fragment);

/**
 * Returns all payload fields expected by the shopping_finished event
 * https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/shopping_finished.yaml
 */
var getShoppingFinishedPayload = function getShoppingFinishedPayload(gqlMarketplaceEntity) {
  var _window, _window$location;
  return (0, _objectSpread2.default)({
    // We need to strip the hyphens since shopping_finished IDs are special (defined as ^[A-Za-z0-9]{32}$ and not as a guid)
    shopping_finish_id: _analytics.default.uuid().replace(/-/g, ''),
    finish_type: 'internal_content',
    source_url_simple: (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href,
    bot_suspected: false
  }, getProductShoppingAttributes(gqlMarketplaceEntity));
};
getShoppingFinishedPayload.fragment = (0, _apollo.gql)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  fragment getShoppingFinishedPayload on MarketplaceEntityInterface {\n    ...getProductShoppingAttributes\n  }\n  ", "\n"])), getProductShoppingAttributes.fragment);
var trackNonMonetizingShoppingFinished = function trackNonMonetizingShoppingFinished(gqlMarketplaceEntity, payloadOverrides) {
  // Avoid executing this function in SSR
  if ((typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) !== 'object') {
    return;
  }
  _analytics.default.track('shopping_finished', (0, _merge2.default)(getShoppingFinishedPayload(gqlMarketplaceEntity), payloadOverrides));
};
exports.trackNonMonetizingShoppingFinished = trackNonMonetizingShoppingFinished;
trackNonMonetizingShoppingFinished.fragment = (0, _apollo.gql)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  fragment trackNonMonetizingShoppingFinished on MarketplaceEntityInterface {\n    ...getShoppingFinishedPayload\n  }\n  ", "\n"])), getShoppingFinishedPayload.fragment);